const marital = [
  { value: 'SOLTEIRO', label: 'SOLTEIRO' },
  { value: 'CASADO', label: 'CASADO' },
  { value: 'SEPARADO', label: 'SEPARADO' },
  { value: 'DIVORCIADO', label: 'DIVORCIADO' },
  { value: 'VIÚVO', label: 'VIÚVO' },
];

export default marital;
